import USER_PREF_PRESETS from './USER_PREF_PRESETS';
import pickBy from 'lodash/pickBy';

const ReturnAs = {
  Int: function (val) {
    return isNaN(parseInt(val, 10)) ? 0 : parseInt(val, 10);
  },
  Float: function (val) {
    return isNaN(parseFloat(val)) ? 0 : parseFloat(val);
  },
  String: (val) => {
    return typeof val === 'string' ? val : val.toString();
  },
};

const getUserPref = (key, userPrefs = {}) => {
  if (key === undefined) {
    return {
      ...USER_PREF_PRESETS,
      ...pickBy(userPrefs, (k) => k === false || k),
    };
  }
  if (Object.keys(userPrefs).length === 0) {
    return USER_PREF_PRESETS[key];
  }

  const selected = userPrefs[key];
  const preset = USER_PREF_PRESETS[key];
  //   let type = typeof USER_PREF_PRESETS[key];

  let val;

  if (selected != null) {
    val = selected;
  } else {
    if (preset === null) {
      console.log('Alarm: Neither state nor preset is defined for ' + key);
      return null;
    }
    val = preset;
  }

  if (val === undefined) {
    console.log('Alarm: Value of ' + key + ' is undefined');
    return null;
  }

  if (Number.isFinite(val)) {
    if (Number.isInteger(val)) {
      return ReturnAs.Int(val);
    } else {
      return ReturnAs.Float(val);
    }
  }

  if (typeof val === 'string') {
    return ReturnAs.String(val);
  }

  return val;
};

export default getUserPref;
